import axios from 'axios';
import Swal from 'sweetalert2';
import ACTION_ITEMS from '../../../actionItems';

export const getPsychQuestion = (candidateId) => async (dispatch) => {
  Swal.fire({
    title: 'processing...',
    onBeforeOpen: () => {
      Swal.showLoading();
    },
  });

  try {
    const response = await axios.get(`/psychometric/${candidateId}/question`);
    const { question, count } = response.data;

    Swal.close();
    dispatch({
      type: ACTION_ITEMS.PSYCHOMETRIC.QUESTION.SET,
      payload: {
        question,
        count,
      },
    });
  } catch (error) {
    Swal.close();
    if (error.response && error.response.data) {
      Swal.fire({
        title: 'Error',
        text: error.response.data.status_message,
        icon: 'error',
      });
    } else {
      console.error(error);
    }
  }
};
